import { useForm, UseFormProps, UseFormReturn } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

export function useFormWithSchema<TSchema extends Yup.ObjectSchema<any>>(
  schema: TSchema,
  config?: UseFormProps<Yup.InferType<TSchema>>
): UseFormReturn<Yup.InferType<TSchema>> {
  return useForm<Yup.InferType<TSchema>>({
    resolver: yupResolver(schema),
    mode: "onSubmit",
    reValidateMode: "onChange",
    ...config,
  });
}
